/**
 * 表格中常用的学生姓名和学号信息
 * @author menghao
 */
import React from "react";
import style from "./index.module.scss";
import { Tooltip } from "antd";

interface StuTableColumnProps {
    name: string;
    stuNo: string;
}

export default function StuTableColumn({ name, stuNo }: StuTableColumnProps) {
    return (
        <div className={style.root}>
            <Tooltip title={name} placement={"topLeft"}>
                <span className={style.name}>{name}</span>
            </Tooltip>
            <span className={style.stuNo}>{stuNo}</span>
        </div>
    );
}
